/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Formatted statement HTML with images placed, the example calls, and repair warnings.
 * @export
 * @interface FormatProblemResponse
 */
export interface FormatProblemResponse {
    /**
     * 
     * @type {string}
     * @memberof FormatProblemResponse
     */
    statement_html: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormatProblemResponse
     */
    examples: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormatProblemResponse
     */
    warnings: Array<string>;
}

/**
 * Check if a given object implements the FormatProblemResponse interface.
 */
export function instanceOfFormatProblemResponse(value: object): value is FormatProblemResponse {
    if (!('statement_html' in value) || value['statement_html'] === undefined) return false;
    if (!('examples' in value) || value['examples'] === undefined) return false;
    if (!('warnings' in value) || value['warnings'] === undefined) return false;
    return true;
}

export function FormatProblemResponseFromJSON(json: any): FormatProblemResponse {
    return FormatProblemResponseFromJSONTyped(json, false);
}

export function FormatProblemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormatProblemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'statement_html': json['statement_html'],
        'examples': json['examples'],
        'warnings': json['warnings'],
    };
}

export function FormatProblemResponseToJSON(json: any): FormatProblemResponse {
    return FormatProblemResponseToJSONTyped(json, false);
}

export function FormatProblemResponseToJSONTyped(value?: FormatProblemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statement_html': value['statement_html'],
        'examples': value['examples'],
        'warnings': value['warnings'],
    };
}

